<script>
  import Header from "./Header.svelte";
  import Links from "./Links.svelte";
  import Content from "./Content.svelte";
  import {isDisplayIssue} from './stores.js';
  
  function signupGoogle(){
		// alert("@signupGoogle");
    firebase.auth().signInWithPopup(provider).then(function(result) {
		// console.log("@signupGoogle2")
		// alert("@signupGoogle2");
    // This gives you a Google Access Token. You can use it to access the Google API.
    // var token = result.credential.accessToken;
    // The signed-in user info.
		let user = result.user;
		console.log("got user="+JSON.stringify(user));
		// userid.set(user.uid);
		// username.set(user.displayName);
		console.log("user.displayName: "+user.displayName);
		updateUserfile(user);
    // ...
    }).catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
			// ...
			console.log(errorMessage+"      "+error.code);
    });
  }
  // console.log("@Shell.svelte")
</script>

<Header></Header>
<div class="recontainer">
  <div class="relinks" class:displaynone={$isDisplayIssue}>
    <Links></Links>
  </div>
  <div id="recontent" class="recontent" class:displaynone={!$isDisplayIssue}>
    <Content></Content>
  </div>
</div>

<style>
  /* h1 {color: greenyellow;} */
  @media (min-width: 800px) {
    .recontainer {display: grid; grid-template-columns: 1fr 1fr;}
  }
  @media (max-width: 1280px) {
  .recontainer {grid-template-columns: 1fr 640px;}
  }
  .recontainer {height: 90%; height: calc(100% - 64px)}
  .relinks {background-color: #f9f9eb; height: 100%; overflow: scroll;}
  .recontent {overflow: scroll; height: 100%; padding: 0 0.5rem;}
  /* background-color: whitesmoke;  */

  /* two columns when >800, otherwise 1 for mobile et al */
  @media (max-width: 800px) {
    /* .issue {display: none;} */
    .displaynone {display:none}
  }
</style>